/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GtmUserTypeEnum {
  LoggedId = 'customer',
  NotLoggedId = 'anonymous'
}
